function toJobTypeFormatter(value: any) {
  if (value) {
    // Underground = 1,
    // Overhead = 2,
    // Drafting = 3,
    // Detailing = 4,
    // ProjectManagement = 5,
    switch (value) {
      case 0:
        return 'Mixed';
        break;

      case 1:
        return 'Underground';
        break;

      case 2:
        return 'Overhead';
        break;

      case 3:
        return 'Drafting';
        break;

      case 4:
        return 'Detailing';
        break;

      case 5:
        return 'Project Management';
        break;

      case 6:
        return 'Design';
        break;

      case 7:
        return 'Undergound Location';
        break;

      case 8:
        return 'Administration';
        break;

      default:
        console.log('Unknown job type:', value);
        return '???';
        break;
    } 
    
  }
}

export default toJobTypeFormatter;
